var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonFunctionalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1515_4503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95443 2.66602H7.95443L9.28776 3.99935H12.6211C12.9747 3.99935 13.3139 4.13982 13.5639 4.38987C13.814 4.63992 13.9544 4.97906 13.9544 5.33268V9.99935C13.9544 10.353 13.814 10.6921 13.5639 10.9422C13.3139 11.1922 12.9747 11.3327 12.6211 11.3327H5.95443C5.60081 11.3327 5.26167 11.1922 5.01162 10.9422C4.76157 10.6921 4.62109 10.353 4.62109 9.99935V3.99935C4.62109 3.64573 4.76157 3.30659 5.01162 3.05654C5.26167 2.80649 5.60081 2.66602 5.95443 2.66602Z",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2865 11.334V12.6673C11.2865 13.0209 11.146 13.3601 10.8959 13.6101C10.6459 13.8602 10.3067 14.0007 9.95313 14.0007H3.28646C2.93284 14.0007 2.5937 13.8602 2.34365 13.6101C2.0936 13.3601 1.95313 13.0209 1.95312 12.6673V6.66732C1.95312 6.3137 2.0936 5.97456 2.34365 5.72451C2.5937 5.47446 2.93284 5.33398 3.28646 5.33398H4.61979",
    stroke: "#4A49CB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1515_4503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonFunctionalIcon);
export default __webpack_public_path__ + "static/media/non-functional-icon.347c5973a2e9608b8d3b9edb82120bce.svg";
export { ForwardRef as ReactComponent };